import { RG_TYPE } from '../../types/rg-type.js';
import { ModuleLikeChildrenTypes } from './module-like-children-types.js';

/** Dictionary of parents and their allowed children type */
const RgChildren = {
    [RG_TYPE.World]: [RG_TYPE.Site],
    [RG_TYPE.Site]: [RG_TYPE.Zone],
    [RG_TYPE.Zone]: [RG_TYPE.Plot],
    [RG_TYPE.Plot]: [RG_TYPE.Building],
    [RG_TYPE.Building]: [RG_TYPE.Apartment, RG_TYPE.Facade, RG_TYPE.Entrance, RG_TYPE.Core, RG_TYPE.TechnicalSpace, RG_TYPE.Corridor, RG_TYPE.Roof, RG_TYPE.Parapet, RG_TYPE.EmptySpace],
    [RG_TYPE.Module]: ModuleLikeChildrenTypes,
    [RG_TYPE.Core]: ModuleLikeChildrenTypes,
    [RG_TYPE.Entrance]: ModuleLikeChildrenTypes,
    [RG_TYPE.TechnicalSpace]: [RG_TYPE.TechnicalSpaceRoom, RG_TYPE.Module],
    [RG_TYPE.TechnicalSpaceRoom]: [],
    [RG_TYPE.Corridor]: ModuleLikeChildrenTypes,
    [RG_TYPE.Balcony]: ModuleLikeChildrenTypes,
    [RG_TYPE.Apartment]: [RG_TYPE.Module, RG_TYPE.Balcony, RG_TYPE.Room],
    [RG_TYPE.Roof]: [],
    [RG_TYPE.Ceiling]: [],
    [RG_TYPE.Floor]: [],
    [RG_TYPE.Wall]: [RG_TYPE.Door, RG_TYPE.Window, RG_TYPE.Opening],
    [RG_TYPE.Facade]: [RG_TYPE.Opening, RG_TYPE.Glazing],
    [RG_TYPE.Window]: [],
    [RG_TYPE.Door]: [],
    [RG_TYPE.Opening]: [],
    [RG_TYPE.Column]: [],
    [RG_TYPE.Beam]: [],
    [RG_TYPE.Room]: [],
    [RG_TYPE.Parapet]: [],
    [RG_TYPE.EmptySpace]: [],
    [RG_TYPE.Glazing]: []
};

export { RgChildren };
//# sourceMappingURL=rg-children.js.map
